// NodeFieldLabel.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './NodeFieldLabel.css';

// Icons
import Icon from 'svg/Icon';

/**
 * NodeFieldLabel
 * 
 * Displays a label for a node field with themed styling and optional settings button on hover.
 * Designed for use in node forms.
 * 
 * @param {string} label - The label text to display.
 * @param {string} description - Optional helper text displayed below the main label.
 * @param {Function} onSettingsClick - Callback when settings button is clicked.
 *  
 *
 * @returns {ReactNode} - NodeFieldLabel.
 */
const NodeFieldLabel = React.memo(({
    description,
    label,
    onSettingsClick,
    showSettings = true,
}) => {

    // ----- CONTEXT ----- //

    // Theme Context

    const { theme } = useTheme();

    // ----- STATE ----- //

    // Hover state

    const [headerHovered, setHeaderHovered] = useState(false);
    const [buttonHovered, setButtonHovered] = useState(false);

    const descriptionText = String(description || '').trim();

    // ----- RENDER ----- //

    return (

        <div
          className="node-field-label-container"
          onMouseEnter={() => setHeaderHovered(true)}
          onMouseLeave={() => setHeaderHovered(false)}
        >

            {/* BODY */}
            <div className="node-field-label-body">

                {/* LABEL */}
                <div
                  className="node-field-label-label"
                >
                    {label}
                </div>

                {/* DESCRIPTION */}
                {descriptionText && (
                    <div
                      className="node-field-label-description"
                    >
                        {descriptionText}
                    </div>
                )}

            </div>

            {/* SETTINGS WRAPPER 
            <div className="node-field-label-settings-wrapper">

                {showSettings && typeof onSettingsClick === 'function' && headerHovered && (
                    <div
                      className="node-field-label-settings"
                      style={{
                            backgroundColor: buttonHovered ? theme.backgroundMuted : 'transparent',
                        }}
                      title="Click to edit field..."
                      onClick={onSettingsClick}
                      onMouseEnter={() => setButtonHovered(true)}
                      onMouseLeave={() => setButtonHovered(false)}
                    >
                        <Icon
                          iconKey="settings"
                          width={18}
                          height={18}
                          color={buttonHovered ? theme.foreground : theme.foregroundMuted}
                        />
                    </div>
                )}

            </div>
            */}

        </div>
    );
});

// Dev Tools
NodeFieldLabel.displayName = 'NodeFieldLabel';

export default NodeFieldLabel;
